/**
 * Routed overlay segments for asset lifecycle management. Pages build their paths from these and
 * `App.tsx` builds its `allowedOverlayPath` lists from the helpers, so the two stay in sync.
 */
export const LIFECYCLE_SEGMENTS = {
  event: "lifecycle-event",
  eventDate: "event-date",
  createEvent: "create-event",
  renew: "renew",
  policies: "lifecycle-policies",
  versionConflict: "version-conflict",
  import: "import",
} as const;

/** Lifecycle management page route, without `/:prefix?`. `App.tsx` prefixes it. */
export const LIFECYCLE_MANAGEMENT_ROUTE = "assets/lifecycle-management";

/** Dashboards whose Upcoming Renewals widget opens the event drawer in place. */
export const LIFECYCLE_EVENT_WIDGET_HOSTS = {
  home: "/:prefix?/home",
  assets: "/:prefix?/assets-dashboard",
  support: "/:prefix?/support",
  services: "/:prefix?/services",
} as const;

/** Event drawer tab slugs, from `toRouteSlug` of `AssetLifecycleManagementDrawerTabNames`. */
export const LIFECYCLE_EVENT_TABS = [
  "event",
  "orders",
  "assets",
  "activity",
] as const;
export type LifecycleEventTab = (typeof LIFECYCLE_EVENT_TABS)[number];
export const LIFECYCLE_EVENT_DEFAULT_TAB: LifecycleEventTab = "event";

export const LIFECYCLE_EVENT_PATH = `${LIFECYCLE_SEGMENTS.event}/:eventId`;
export const LIFECYCLE_POLICIES_VERSION_CONFLICT_PATH = `${LIFECYCLE_SEGMENTS.policies}/${LIFECYCLE_SEGMENTS.versionConflict}`;

/** The event drawer, which also opens globally from the Upcoming Renewals widget. */
export const lifecycleEventOverlayPaths = (base: string): string[] => [
  `${base}/${LIFECYCLE_EVENT_PATH}/:tab?`,
  `${base}/${LIFECYCLE_EVENT_PATH}/:tab/${LIFECYCLE_SEGMENTS.eventDate}`,
];

export const lifecycleManagementOverlayPaths = (base: string): string[] => [
  ...lifecycleEventOverlayPaths(base),
  `${base}/${LIFECYCLE_SEGMENTS.createEvent}`,
  `${base}/${LIFECYCLE_SEGMENTS.renew}`,
  `${base}/${LIFECYCLE_SEGMENTS.policies}`,
  `${base}/${LIFECYCLE_POLICIES_VERSION_CONFLICT_PATH}`,
  `${base}/${LIFECYCLE_SEGMENTS.import}`,
];
